import { Link } from "react-router";

import { Chip, type ChipVariant } from "@/components/atomic-crm/shared/Chip";

import type { MiniListPayload } from "./types";

// Sprint 9.3 — Bloc MiniList : liste compacte d'items (companies, tickets, contacts).
// Émis par l'agent quand 5-15 items doivent être affichés en strip dense.

const ENTITY_PATH = {
  deal: "deals",
  contact: "contacts",
  company: "companies",
  task: "tasks",
  dev_task: "dev_tasks",
  appointment: "appointments",
} as const;

export function MiniListBlock({ payload }: { payload: MiniListPayload }) {
  return (
    <div className="rounded-fabrik-card border border-border bg-card overflow-hidden shadow-card">
      {payload.title && (
        <p className="text-[13px] font-semibold text-foreground px-4 py-2 border-b border-border">
          {payload.title}
        </p>
      )}
      <ul className="divide-y divide-border/60">
        {payload.items.map((item, i) => {
          const content = (
            <div className="flex items-center gap-3 px-4 py-2 hover:bg-fabrik-green-soft/30 transition-colors">
              <div className="min-w-0 flex-1">
                <p className="text-[13px] font-medium text-foreground truncate">
                  {item.label}
                </p>
                {item.sublabel && (
                  <p className="text-[11.5px] text-fabrik-text-3 truncate">
                    {item.sublabel}
                  </p>
                )}
              </div>
              {item.badge && (
                <Chip variant={(item.badgeVariant ?? "gray") as ChipVariant}>
                  {item.badge}
                </Chip>
              )}
            </div>
          );
          if (item.entity) {
            return (
              <li key={item.id ?? i}>
                <Link
                  to={`/${ENTITY_PATH[item.entity.type]}/${item.entity.id}/show`}
                  className="block"
                >
                  {content}
                </Link>
              </li>
            );
          }
          return <li key={item.id ?? i}>{content}</li>;
        })}
      </ul>
    </div>
  );
}
